import { render } from "./WangosProjectTwo.vue?vue&type=template&id=f56c6186"
import script from "./WangosProjectTwo.vue?vue&type=script&lang=js"
export * from "./WangosProjectTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__